import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { EntityListAction, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { AccountService, GridFilter, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ReviewService } from "src/app/review/review.service";
import { ReviewFilterItem } from "../../../../review/models/review-filter-item";
import { Element } from "../../models/base-info/element.model";
import { ElementGroup } from "../../models/enums/element-group";
import { ElemntshowKind } from "../../models/enums/elemntshow-kind";

@Component({
  selector: "ngx-hrm-review",
  templateUrl: "./hrm-review.component.html",
  styleUrls: ["./hrm-review.component.scss"],
  providers: [ReviewService],
})
export class HrmReviewComponent implements OnInit, OnDestroy {
  actions: EntityListAction[];
  unSortableFilterable: string[] = [];
  formGroup: UntypedFormGroup;
  protected ngUnsubscribe = new Subject<void>();
  HrmReviewColumns: form_control[];
  selected: string = "";
  HrmPersonnelIds: number[] = [];
  BackPayHrmPersonnelIds: number[] = [];
  TotallHrmPersonnelIds: number[] = [];
  EmploymentKindIds: number[] = [];
  WorkplaceIds: number[] = [];
  CostCenterIds: number[] = [];
  ElementGroupIds: number[] = [];
  isloaded: boolean = false;
  permisionList: NameValue[] = [];
  public activeTabTitle: string;
  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    private accountService: AccountService,
    private httpCommonService: HttpCommonService,
    protected translateText: TranslateService
  ) {}

  translate = function _translate(str: string): string {
    return this.translateText.instant(str);
  };
  ngOnInit(): void {
    this.formGroup = this.fb.group({
      EmploymentKindIds: this.EmploymentKindIds,
      WorkplaceIds: this.WorkplaceIds,
      CostCenterIds: this.CostCenterIds,
      ElementGroupIds: this.ElementGroupIds,
      StartYear: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
      EndYear: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
      StartMonth: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
      EndMonth: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
    });

    this.populateGridColumns(false);
  }

  populateGridColumns(ShowBeforeRemain: boolean): any {
    var _HrmReviewColumns: form_control[] = [
      {
        name: "HrmPersonnelId",
        modelName: "HrmPersonnelId",
        listVisible: false,
        label: "سریال",
        order: 0,
        textType: "number",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "EmploymentKindTitle",
        modelName: "EmploymentKindTitle",
        listVisible: true,
        label: "نوع استخدام",
        order: 1,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "WorkplaceTitle",
        modelName: "WorkplaceTitle",
        listVisible: true,
        label: "محل خدمت",
        order: 2,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "CostCenterTitle",
        modelName: "CostCenterTitle",
        listVisible: true,
        label: "مرکز هزرینه",
        order: 3,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "PersCode",
        modelName: "PersCode",
        listVisible: true,
        label: "کد پرسنلی",
        order: 4,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "FirstName",
        modelName: "FirstName",
        listVisible: true,
        label: "نام",
        order: 5,
        textType: "text",
        withComma: false,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "LastName",
        modelName: "LastName",
        listVisible: true,
        label: "نام خانوادگی",
        order: 6,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "IssueYear",
        modelName: "IssueYear",
        listVisible: true,
        label: "سال اجراء",
        order: 7,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "IssueMonth",
        modelName: "IssueMonth",
        listVisible: true,
        label: "ماه اجراء",
        order: 8,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "EffectYear",
        modelName: "EffectYear",
        listVisible: true,
        label: "سال تاثیر",
        order: 9,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "EffectMonth",
        modelName: "EffectMonth",
        listVisible: true,
        label: "ماه تاثیر",
        order: 10,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];

    let filter: GridFilter[] = [];
    this.ElementGroupIds = this.formGroup.get("ElementGroupIds").value;
    this.EmploymentKindIds = this.formGroup.get("EmploymentKindIds").value;
    if (this.ElementGroupIds && this.ElementGroupIds.length > 0)
      filter.push({ Type: "F", Filed: "ElementGroupIds", Value: this.ElementGroupIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    if (this.EmploymentKindIds && this.EmploymentKindIds.length > 0)
      filter.push({ Type: "F", Filed: "EmploymentKindIds", Value: this.EmploymentKindIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({
      Type: "F",
      Filed: "IssueYear",
      Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    filter.push({
      Type: "F",
      Filed: "IssueMonth",
      Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });

    let cCount = 10;
    this.httpCommonService
      .create("MonthlySalaryCalculationInformation/GetActiveElement", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Element[]) => {
        if (x) {
          var activeElement = x;
          activeElement.forEach((e) => {
            cCount = cCount + 1;
            if (e.ElementGroupCode === ElementGroup.Work) {
              if (e.ElemntshowKindCode === ElemntshowKind.DDHHMM)
                _HrmReviewColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "00:00:00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MV_${e.Id}`,
                  disabled: false,
                  name: `MV_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else if (e.ElemntshowKindCode === ElemntshowKind.HHMM)
                _HrmReviewColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "000:00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MV_${e.Id}`,
                  disabled: false,
                  name: `MV_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else if (e.ElemntshowKindCode === ElemntshowKind.DD)
                _HrmReviewColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MV_${e.Id}`,
                  disabled: false,
                  name: `MV_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else
                _HrmReviewColumns.push(<form_control>{
                  label: e.Title,
                  controlType: FormControlTypes.textbox,
                  columnWidth: 100,
                  modelName: `MV_${e.Id}`,
                  disabled: false,
                  name: `MV_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
            } else
              _HrmReviewColumns.push(<form_control>{
                label: e.Title,
                controlType: FormControlTypes.textbox,
                columnWidth: 100,
                modelName: `MV_${e.Id}`,
                disabled: false,
                name: `MV_${e.Id}`,
                order: cCount,
                textType: "number",
                withComma: true,
                formVisible: true,
                listVisible: true,
                required: false,
                format: "#,#",
              });
          });
          this.HrmReviewColumns = _HrmReviewColumns.sort((a, b) => a.order - b.order);
        }
      });
    this.service.addFilter("StartYear", [
      <ReviewFilterItem>{
        key: "StartYear",
        value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
        title: "از سال",
        persianKey: "از سال",
        valueType: "number",
        checked: false,
      },
      <ReviewFilterItem>{
        key: "EndYear",
        value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
        title: "تا سال",
        persianKey: "تا سال",
        valueType: "number",
        checked: false,
      },
      <ReviewFilterItem>{
        key: "StartMonth",
        value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
        title: "از ماه",
        persianKey: "از ماه",
        valueType: "number",
        checked: false,
      },
      <ReviewFilterItem>{
        key: "EndMonth",
        value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
        title: "تا ماه",
        persianKey: "تا ماه",
        valueType: "number",
        checked: false,
      },
    ]);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.actions = undefined;
    this.unSortableFilterable = undefined;
    this.formGroup = undefined;
    this.HrmReviewColumns = undefined;
    this.HrmPersonnelIds = undefined;
    this.BackPayHrmPersonnelIds = undefined;
    this.TotallHrmPersonnelIds = undefined;
    this.EmploymentKindIds = undefined;
    this.WorkplaceIds = undefined;
    this.CostCenterIds = undefined;
    this.ElementGroupIds = undefined;
    this.permisionList = undefined;
  }

  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
  onChange(event) {
    this.populateGridColumns(false);
  }
}
